import { defineModel } from "../define-model";

export type Platform = "instagram" | "tiktok" | "facebook" | "threads" | "x";
export type Weekday = "mon" | "tue" | "wed" | "thu" | "fri" | "sat" | "sun";
export type ContentFormat = "post" | "carousel" | "reel" | "story" | "thread" | "short_video";

export type StrategyGoal = { title: string; metric?: string; target?: number };
export type StrategyAudience = { name: string; description: string };
export type StrategyPillar = { name: string; description: string; share?: number };
export type StrategyVoice = { tone?: string; traits?: string[]; do?: string[]; dont?: string[] };
export type StrategyPlatformPlan = {
	cadencePerWeek?: number;
	days?: Weekday[];
	formats?: ContentFormat[];
	guidance?: string;
};
export type StrategyKpi = { name: string; target?: string; baseline?: string };

export type Strategy = {
	id: string;
	workspaceId: string;
	projectId: string;
	title: string;
	status: "draft" | "active" | "archived";
	summary: string;
	body: string;
	goals: StrategyGoal[];
	audiences: StrategyAudience[];
	pillars: StrategyPillar[];
	voice: StrategyVoice;
	platforms: Partial<Record<Platform, StrategyPlatformPlan>>;
	kpis: { items?: StrategyKpi[] };
	authorType: "user" | "assistant" | "system";
	createdById: string | null;
	archivedAt: string | null;
	createdAt: string;
	updatedAt: string;
};

declare module "../types" {
	interface SyncModels {
		strategy: Strategy;
	}
}

export const model = defineModel({
	name: "strategy",
	load: "eager",
	indexes: ["projectId"],
	defaults: ({ userId, workspaceId, now }) => ({
		workspaceId,
		status: "draft" as const,
		summary: "",
		body: "",
		goals: [],
		audiences: [],
		pillars: [],
		voice: {},
		platforms: {},
		kpis: {},
		authorType: "user" as const,
		createdById: userId,
		archivedAt: null,
		createdAt: now,
		updatedAt: now,
	}),
	sort: (a, b) => b.updatedAt.localeCompare(a.updatedAt),
});
